import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TopToolbar = ({ onSave, onUndo, onRedo, onPreview, canUndo, canRedo }) => {
  const navigate = useNavigate();
  const [activeBreakpoint, setActiveBreakpoint] = useState('desktop');
  const [isSaving, setIsSaving] = useState(false);

  const breakpoints = [
    { id: 'mobile', label: 'Mobile', icon: 'Smartphone', width: '375px' },
    { id: 'tablet', label: 'Tablet', icon: 'Tablet', width: '768px' },
    { id: 'desktop', label: 'Desktop', icon: 'Monitor', width: '100%' }
  ];

  const handleSave = async () => {
    setIsSaving(true);
    await onSave();
    setTimeout(() => setIsSaving(false), 1000);
  };

  return (
    <div className="bg-card border-b border-border">
      <div className="flex items-center justify-between px-4 py-3 gap-4">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/project-dashboard')}
            className="p-2 rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground transition-all duration-250"
            aria-label="Back to dashboard"
          >
            <Icon name="ArrowLeft" size={20} />
          </button>
          
          <div className="hidden md:flex items-center gap-2 pl-3 border-l border-border">
            <h1 className="font-heading font-semibold text-base lg:text-lg text-foreground">
              Visual Builder
            </h1>
            <span className="px-2 py-0.5 bg-primary/10 text-primary text-xs font-medium rounded">
              Editing
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <div className="hidden lg:flex items-center gap-1 bg-muted rounded-lg p-1">
            {breakpoints?.map((breakpoint) => (
              <button
                key={breakpoint?.id}
                onClick={() => setActiveBreakpoint(breakpoint?.id)}
                className={`flex items-center gap-2 px-3 py-2 rounded-md transition-all duration-250 ${
                  activeBreakpoint === breakpoint?.id
                    ? 'bg-card text-foreground shadow-sm'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
                title={breakpoint?.label}
              >
                <Icon name={breakpoint?.icon} size={16} />
                <span className="text-xs font-medium hidden xl:inline">{breakpoint?.label}</span>
              </button>
            ))}
          </div>

          <div className="flex items-center gap-1 pl-2 lg:pl-4 border-l border-border">
            <button
              onClick={onUndo}
              disabled={!canUndo}
              className="p-2 rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground transition-all duration-250 disabled:opacity-40 disabled:cursor-not-allowed"
              aria-label="Undo"
            >
              <Icon name="Undo2" size={18} />
            </button>
            <button
              onClick={onRedo}
              disabled={!canRedo}
              className="p-2 rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground transition-all duration-250 disabled:opacity-40 disabled:cursor-not-allowed"
              aria-label="Redo"
            >
              <Icon name="Redo2" size={18} />
            </button>
          </div>

          <div className="flex items-center gap-2 pl-2 lg:pl-4 border-l border-border">
            <Button
              variant="outline"
              size="sm"
              iconName="Eye"
              iconPosition="left"
              onClick={onPreview}
              className="hidden md:flex"
            >
              Preview
            </Button>
            <Button
              variant="default"
              size="sm"
              iconName="Save"
              iconPosition="left"
              loading={isSaving}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopToolbar;